<template>
  <page v-model:filter="q" :name="$t('My cloud')" :empty="servers.length <= 0" :state="serversState">
    <template #toolbar-pre>
      <pf-button variant="primary" @click="popupWizard = true" ouia-id="new-server-button">
        {{ $t('Attiva nuovo server') }}
      </pf-button>
    </template>
    <pf-page-section>
      <pf-gallery gutter min-width-sm="40ch">
        <server-detail :server="server" v-for="server in filtered" :key="server.id" />
      </pf-gallery>
    </pf-page-section>
  </page>

  <wizard-modal-server v-if="popupWizard" @close="popupWizard = false" />
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { ServerResource } from '@/resources';
import { asyncComputedList } from '@common/asyncComputed';
import { any } from '@common/utils';
import WizardModalServer from '../components/wizard/wizard-modal-server.vue';

import ServerDetail from '../components/server-detail.vue';

const { state: serversState, result: servers } = asyncComputedList(() => new ServerResource().get());

const q = ref('');
const filtered = computed(() => servers.value.filter(any(q.value)));
const popupWizard = ref(false);
</script>
